import React from 'react'
import SimpleStepNav from '../navigation/SimpleStepNav'
import InputRadioBox from '../inputs/InputRadioBox'
import InputWrapper from '../inputs/InputWrapper'
import WhenCondition from '../misc/WhenCondition'
import InputWeeks from '../inputs/InputWeeks'
import FormHeader from '../inputs/FormHeader'
import useNavigationManager from '../hooks/use-navigation-manager'
import useSettingsManager from '../hooks/use-settings-manager'
import ConfirmManualInstallation from '../misc/ConfirmManualInstallation'
import ValidationError from '../inputs/ValidationError'
import OtherOptionWysisygContent from '../misc/OtherOptionWysisygContent'

function DeliveryStep () {
  const nav_manager = useNavigationManager()
  const settings_manager = useSettingsManager()
  const step_index = 3
  const step_name = nav_manager.getStepName(step_index)
  const strings = settings_manager.getStepSettings(step_name)

  return (
    <React.Fragment>
      <FormHeader htag={'h1'} strings={strings}/>

      <InputWrapper name={'delivery'}>
        <InputRadioBox value={'no'} size={'half'}/>
        <InputRadioBox value={'yes'} size={'half'}/>
      </InputWrapper>

      <InputWrapper name={'installation'}>
        <ConfirmManualInstallation>
          <InputRadioBox name={'installation'} value={'no'} size={'half'}/>
        </ConfirmManualInstallation>
        <InputRadioBox value={'yes'} size={'half'}/>
      </InputWrapper>

      <WhenCondition condition={'hasInstallation'}>
        <InputWrapper name={'date'} grid={null}>
          <InputWeeks/>
        </InputWrapper>
      </WhenCondition>

      <InputWrapper name={'uninstallation'}>
        <InputRadioBox value={'no'} size={'half'}/>
        <WhenCondition condition={'hasInstallation'}>
          <InputRadioBox name={'uninstallation'} value={'yes'} size={'half'}/>
        </WhenCondition>
        <ValidationError>
          <OtherOptionWysisygContent name={'ve_uninstallation'}/>
        </ValidationError>
      </InputWrapper>

      <SimpleStepNav step_name={step_name}/>
    </React.Fragment>
  )
}

export default DeliveryStep